const getImageSource = imgSrc => {
  if (!imgSrc) return '';

  if (typeof imgSrc === 'object' && imgSrc.src) {
    return imgSrc.src;
  }

  if (typeof imgSrc === 'string') {
    return imgSrc;
  }

  return '';
};

export { getImageSource };
